import {
  DeliverySlipIndex,
  DeliverySlipCreator,
  DeliverySlipViewer,
  DeliverySlipCloser,
  DeliverySlipHistory
} from "../views";

export const deliverySlipRouter = {
  main: [
    {
      path: "deliveryslip/",
      name: "DeliverySlipIndex",
      component: DeliverySlipIndex
    },
    {
      path: "deliveryslip/history",
      name: "DeliverySlipHistory",
      component: DeliverySlipHistory
    },
    {
      path: "deliveryslip/create/",
      name: "DeliverySlipCreator",
      component: DeliverySlipCreator
    },
    {
      path: "deliveryslip/closer/:id",
      name: "DeliverySlipCloser",
      component: DeliverySlipCloser,
      props: true
    }
  ],
  viewer: [
    {
      path: "deliveryslip/:id",
      name: "DeliverySlipViewer",
      component: DeliverySlipViewer,
      props: true
    }
  ]
};
